import styled from "styled-components";

import { FlexDiv } from "@/components/Atoms/Box";
import Image from "@/components/Atoms/Image";
import Typography from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

export const StyledFeature = styled(FlexDiv)`
  align-items: center;
  gap: 16px;
  padding: 8px;
`;

export const StyledImage = styled(Image)`
  height: 16px;
  width: 16px;
`;

export const StyledTitle = styled(Typography)`
  font-family: var(--man-700);
  color: ${theme.colorsV2.gray.shade_800};

  @media only screen and (max-width: 600px) {
    font-family: var(--man-600);
    font-size: 16px;
    line-height: 24px;
  }
`;
